import { AuthContextModel } from "../App";
import * as Utils from "../utils/Config";
import { ApiClient, IPaginatedResponse } from "./ApiClient";
import { IImportedXmlTypes, IImportedXmlSummary, ISubmitXmlFile, IImportedXmlSearchParams, IImportedXmlDetails } from "../models/IImportedXml";
import { objectToQueryString } from "../helpers/ApiHelper";
import { ICareProvider } from "../models/ICareProvider";

export class ImportXmlApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    getImportedXmls(searchParams: IImportedXmlSearchParams, success: (data: IPaginatedResponse<IImportedXmlSummary[]>) => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getPaginated<IImportedXmlSummary[]>(`${Utils.LIB_API_BASE_URL}/importXmls?${queryString}`, success, error, final);
    }

    getImportedXml(importedXmlId: string, exportToExcel: boolean, careProviderId: string, success?: (data: IImportedXmlDetails) => void, fileName?: string, error?: (message: string) => void, final?: () => void) {
        var url = careProviderId === undefined 
            ? `${Utils.LIB_API_BASE_URL}/importXmls/${importedXmlId}/${exportToExcel}` 
            : `${Utils.LIB_API_BASE_URL}/importXmls/${importedXmlId}/${exportToExcel}/${careProviderId}`
        
        if (exportToExcel) {
            this.getFile(url, fileName, undefined, error, final)
        }
        if (success) {
            this.get<IImportedXmlDetails>(url, success, error, final);
        }
    }

    uploadXmlFile(uploadedXml: ISubmitXmlFile, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/importXmls/${uploadedXml.importedXmlTypeId}`, uploadedXml, success, error, final);
    }

    getXmlTypes(success: (data: IImportedXmlTypes[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IImportedXmlTypes[]>(`${Utils.LIB_API_BASE_URL}/importXmls/types`, success, error, final);
    }

    getUmbrellaOrganisations(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/importXmls/umbrellaOgranisations`, success, error, final);
    }

    getUmbrellaCareProviders(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICareProvider[]>(`${Utils.LIB_API_BASE_URL}/importXmls/careProviders/`, success, error, final);
    }

    getCareProvidersByUmbrellaCareProviderId(umbrellaCareProviderId: number, success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICareProvider[]>(`${Utils.LIB_API_BASE_URL}/importXmls/careProviders/${umbrellaCareProviderId}`, success, error, final);
    }

    getXmlFile(importedXmlId: number, success?: () => void, error?: (message: string) => void, final?: () => void) {
        this.getFile(`${Utils.LIB_API_BASE_URL}/importXmls/files/${importedXmlId}`, undefined, success, error, final);
    }
}